import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { AbcButtonComponent } from '@barthauer/abc/ui-components';
import { ControlButton } from 'libs/abc/queries/opath/core/src/lib/viewModels/layout.viewModel';
import { Observable, Subject, fromEvent, merge, timer } from 'rxjs';
import { debounce, map, takeUntil } from 'rxjs/operators';
import { EditorHistory } from '../../models/expressions-editor-opath.model';
import { MenuButtonEnum } from '../../models/menu.model';
import { TranslationConfiguration } from '../../models/view.model';
import { EditorService } from '../../services/editor.service';
import { SharedService } from '../../services/shared.service';

@Component({
  selector: 'expressions-editor-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],
})
export class MenuComponent implements OnInit, OnChanges, OnDestroy {
  @ViewChild('undoButton') undoButton : AbcButtonComponent
  @ViewChild('redoButton') redoButton : AbcButtonComponent
  @Input() redoHistory: EditorHistory[] = [];
  @Input() editorInitialValue: string;
  @Input() editorContent: string
  @Input() columnTitle: {
    initialValue: string,
    currentValue: string
  };
  @Input() undoHistory: EditorHistory[] = [];
  @Input() neutralDesignationActive: boolean;
  @Input() height: number
  @Output() onMenuButtonClick : EventEmitter<MenuButtonEnum> = new EventEmitter<MenuButtonEnum>;


  public translation : TranslationConfiguration
  private unsubscribe$: Subject<void> = new Subject<void>();

  constructor(private sharedService : SharedService, private editorService: EditorService) {
    this.translation = this.sharedService.translation
  }
  ngOnChanges(changes: SimpleChanges): void {
    if ( changes['neutralDesignationActive']?.currentValue) {
      this.neutralDesignationActive = changes['neutralDesignationActive'].currentValue;
    }
  }

  public menuButtons: ControlButton[] =[]
 

  public ngOnInit(): void {
    this.bindKeypressEvent()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((event: KeyboardEvent) => this.onKeyPress(event));
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  public onResetClick(): void {
    this.onMenuButtonClick.emit(MenuButtonEnum.Reset)
  }
  public onUndoClick(): void {
    this.onMenuButtonClick.emit(MenuButtonEnum.Undo)
  }
  public onSaveCloseClick(): void {
    this.onMenuButtonClick.emit(MenuButtonEnum.SaveClose);
  }
  public onRedoClick(): void {
    this.onMenuButtonClick.emit(MenuButtonEnum.Redo)
  }
  public onValidateClick(): void {
    this.onMenuButtonClick.emit(MenuButtonEnum.Validate)
  }
  public onToggleNeutralDesignationClick(): void {
    this.onMenuButtonClick.emit(MenuButtonEnum.ToggleNeutralDesignation)
  }
  public onKeyPress($event: KeyboardEvent): void {
    if ($event.ctrlKey) {
      switch ($event.keyCode) {
        case 90:
        case 26:
          this.onMenuButtonClick.emit(MenuButtonEnum.Undo);
          break;
        case 89:
        case 25:
          this.onMenuButtonClick.emit(MenuButtonEnum.Redo);
          break;
        default:
          break;
      }
    }
  }

  private bindKeypressEvent(): Observable<KeyboardEvent> {
    const eventsType = [fromEvent(window, 'keypress'), fromEvent(window, 'keydown')];
    // we merge all kind of event as one observable.
    return merge(...eventsType).pipe(
      debounce(() => timer(2)),
      map((state) => state as KeyboardEvent)
    );
  }

}
